import {
  Home,
  Settings,
  UserCircle,
  Package,
  Tag,
  ListOrdered,
} from "lucide-react";

export const sidebarItems = [
  {
    id: 1,
    label: "Home",
    parent_id: null,
    icon: Home,
    module: "home",
    order_index: 1,
    url: "/",
  },
  {
    id: 2,
    label: "Products",
    parent_id: null,
    icon: Package,
    module: "products",
    order_index: 7,
    url: "/products",
  },
  {
    id: 3,
    label: "Categories",
    parent_id: null,
    icon: Tag,
    module: "categories",
    order_index: 2,
    url: "/categories",
  },

  {
    id: 4,
    label: "Orders",
    parent_id: null,
    icon: ListOrdered,
    module: "orders",
    order_index: 4,
    url: "/orders",
  },
  {
    id: 5,
    label: "Settings",
    parent_id: null,
    icon: Settings,
    module: "settings",
    order_index: 5,
    url: "/settings",
  },
  {
    id: 6,
    label: "Profile",
    parent_id: null,
    icon: UserCircle,
    module: "profile",
    order_index: 6,
    url: "/profile",
  },
];
